import React, { Component } from "react";
import "../../../sass/applications.scss";
import imgLogo from "../../../images/logo.png";
import imgLogoPaychex from "../../../images/paychex-logo.png";
import imgLogoBig from "../../../images/logo-big.png";
import { Link, withRouter } from "react-router-dom";
import imgMobileMenu from "../../../images/mobile-menu.png";
import imgNotifications from "../../../images/notifications.png";
import imgAvatar from "../../../images/avatar-default.png";
import { NavDropdown, Dropdown, NavItem, NavLink } from "react-bootstrap";
import config from "../../config";
import AddApplicationModal from "../modals/add-new-application-modal/add-applications-modal";
import HeaderMenu from "../preapps/HeaderMenu";
import EMSBootModal from "../modals/add-new-application-modal/ems-boot-application-modal";
import { UserData } from "../../api";
const MOBILE_SCREEN_WIDTH = 767;
const MAIN_URL = config.paymentcloud.MAIN_URL;
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            showMobileMenu: false,
            betaFeature: false,
            CreateUrl: "",
            showCreatedAppModel: false,
            hideMenuOptions: false,
            editPrevet: false,
            editPrevetId: null,
            showEmsBootModal: false,
        };
        this.wrapperRef = React.createRef();
        this.handler = this.handler.bind(this);
    }

    handleResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        });
    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        window.addEventListener("mousedown", this.handleClickOutside);
        if (this.props.user && this.props.user.channel == "sales_channel") {
            this.setState({ hideMenuOptions: true });
        }
    }

    handler = () => {
        this.props.getPreAppData();
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (
            this.state.showMobileMenu &&
            this.wrapperRef &&
            !this.wrapperRef.current.contains(event.target)
        ) {
            this.setState({ showMobileMenu: false });
        }
    };

    handleShowMenu() {
        this.setState({ showMobileMenu: true });
    }

    handleHideMenu = () => {
        this.setState({ showMobileMenu: false });
    };

    handleCallBackAndHideMenu = () => {
        if (typeof this.props.resetFilter === "function") {
            this.props.resetFilter();
        }
        this.handleHideMenu();
    };

    handleShowAddApplicationModel = () => {
        if (this.props.user?.channel == 'isv_channel') {
            this.setState({ editPrevet: false, showCreatedAppModel: true });
        } else {
            this.setState({ editPrevet: false, showEmsBootModal: true });

        }
    };

    render() {
        const application_url = config.paymentcloud.MAIN_URL;
        const user = this.props.user;
        let organisation_slug = "";
        if (user.agent_url) {
            if (user.organization) {
                organisation_slug = user.organization.whitelabel_slug;
            }
            if (this.state.CreateUrl.length == 0 && organisation_slug.length) {
                let URLCreate = "";
                if (user?.channel == "sales_channel") {
                    URLCreate = MAIN_URL + user.agent_url;
                } else {
                    URLCreate =
                        MAIN_URL + organisation_slug + "/" + user.agent_url;
                }
                this.setState({
                    CreateUrl: URLCreate,
                });
            }
        }
        const { windowWidth, windowHeight, showMobileMenu } = this.state;
        const isMobile = windowWidth < MOBILE_SCREEN_WIDTH;
        let userName = user.name || "";
        const menuStyle = {};
        if (isMobile) {
            userName = null;
            Object.assign(menuStyle, {
                height: windowHeight + "px",
            });
        }
        const isPcAdmin =
            user && user.role === "admin" && user.organization_id == 1;
        const is_ems_pc_admin = user && user.is_ems_pc_admin;
        return (
            <div>
                {Object.keys(this.props.user).length == 0 ? (
                    ""
                ) : (
                    <div>
                        <header className="header">
                            <div className="container-fluid">
                                <div className="header-row">
                                    <div className="header-dashboard-col">
                                        <div className="header-dashboard">
                                            {isMobile ? (
                                                <>
                                                    <a
                                                        href="javascript:void(0)"
                                                        onClick={() =>
                                                            this.handleShowMenu()
                                                        }
                                                    >
                                                        <img
                                                            className="logo"
                                                            src={imgMobileMenu}
                                                            alt="PaymentCloud.com"
                                                        />
                                                    </a>
                                                    <div
                                                        ref={this.wrapperRef}
                                                        className={
                                                            showMobileMenu
                                                                ? "mobile-menu show"
                                                                : "mobile-menu"
                                                        }
                                                        style={menuStyle}
                                                    >
                                                        <a href="/">
                                                            <img
                                                                src={imgLogoBig}
                                                            />
                                                        </a>
                                                        <span className="separator" />
                                                        <ul>
                                                            <li>
                                                                <Link
                                                                    to="/applications"
                                                                    onClick={
                                                                        this
                                                                            .handleCallBackAndHideMenu
                                                                    }
                                                                >
                                                                    Applications
                                                                </Link>
                                                            </li>
                                                            {!!this.props.user
                                                                .organization
                                                                .enable_agent_training && (
                                                                <li>
                                                                    <Link
                                                                        target="_blank"
                                                                        to="https://paymentcloud.isoquote.com/oidc/240518168592/start"
                                                                        onClick={
                                                                            this
                                                                                .handleHideMenu
                                                                        }
                                                                    >
                                                                        Agent
                                                                        Training
                                                                    </Link>
                                                                </li>
                                                            )}
                                                            <li>
                                                                <Link
                                                                    to="/merchants"
                                                                    onClick={
                                                                        this
                                                                            .handleCallBackAndHideMenu
                                                                    }
                                                                >
                                                                    Merchants
                                                                </Link>
                                                            </li>
                                                            {((user.role ===
                                                                "agent" &&
                                                                user.is_view_residual) ||
                                                                user.role ===
                                                                    "admin") && (
                                                                <li>
                                                                    <Link
                                                                        to="/organization"
                                                                        onClick={
                                                                            this
                                                                                .handleHideMenu
                                                                        }
                                                                    >
                                                                        Organizations
                                                                    </Link>
                                                                </li>
                                                            )}
                                                            {this.state
                                                                .hideMenuOptions ===
                                                            false ? (
                                                                <>
                                                                    <li>
                                                                        <Link
                                                                            to="/pricing-equipment"
                                                                            onClick={
                                                                                this
                                                                                    .handleHideMenu
                                                                            }
                                                                        >
                                                                            Templates
                                                                        </Link>
                                                                    </li>
                                                                    {user.role ===
                                                                        "admin" &&
                                                                        config.paymentcloud &&
                                                                        config
                                                                            .paymentcloud
                                                                            .RESIDUAL_SYSTEM &&
                                                                        config.paymentcloud.RESIDUAL_SYSTEM.includes(
                                                                            user.id,
                                                                        ) && (
                                                                            <li>
                                                                                <Link
                                                                                    to="/residuals"
                                                                                    onClick={
                                                                                        this
                                                                                            .handleHideMenu
                                                                                    }
                                                                                >
                                                                                    residuals
                                                                                </Link>
                                                                            </li>
                                                                        )}

                                                                    {isPcAdmin && (
                                                                        <li>
                                                                            <Link
                                                                                to="/mcc"
                                                                                onClick={
                                                                                    this
                                                                                        .handleHideMenu
                                                                                }
                                                                            >
                                                                                Mcc
                                                                            </Link>
                                                                        </li>
                                                                    )}
                                                                    {isPcAdmin && (
                                                                        <li>
                                                                            <Link
                                                                                to="/bank"
                                                                                onClick={
                                                                                    this
                                                                                        .handleHideMenu
                                                                                }
                                                                            >
                                                                                Processors
                                                                            </Link>
                                                                        </li>
                                                                    )}
                                                                </>
                                                            ) : null}
                                                        </ul>
                                                    </div>
                                                </>
                                            ) : (
                                                <Link
                                                            to={"/applications"}
                                                    onClick={() =>
                                                        this.props.tabShowActive(
                                                            "dashboard",
                                                        )
                                                    }
                                                >
                                                    {user.organization_id ===
                                                    config.paymentcloud
                                                        .PAYCHEX_ORG_ID ? (
                                                        <img
                                                            className="logo"
                                                            src={imgLogoPaychex}
                                                            alt="PaymentCloud.com"
                                                        />
                                                    ) : (
                                                        <img
                                                            className="logo"
                                                            src={imgLogo}
                                                            alt="PaymentCloud.com"
                                                        />
                                                    )}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                    <div className="header-menu-col">
                                        <div className="header-menu">
                                            <ul className="header-tabs-groupwise">
                                                <li>
                                                    {this.props.user
                                                        ?.organization
                                                        ?.show_create ? (
                                                        <a
                                                            className={
                                                                "new-app-button"
                                                            }
                                                            title="Create"
                                                            onClick={() =>
                                                                this.handleShowAddApplicationModel()
                                                            }
                                                        >
                                                            <svg
                                                                width="12"
                                                                height="12"
                                                                viewBox="0 0 12 12"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M6.75 0H5.25V5.25H0V6.75H5.25V12H6.75V6.75H12V5.25H6.75V0Z"
                                                                    fill="white"
                                                                />
                                                            </svg>
                                                            <span>Create</span>
                                                        </a>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </li>
                                                {isMobile ? (
                                                    ""
                                                ) : (
                                                    <HeaderMenu
                                                        isPcAdmin={isPcAdmin}
                                                        hideMenuOptions={
                                                            this.state
                                                                .hideMenuOptions
                                                        }
                                                        user={user}
                                                        currentRoute={
                                                            this.props
                                                                .currentRoute
                                                        }
                                                        tabShowActive={(path) =>
                                                            this.props.tabShowActive(
                                                                path,
                                                            )
                                                        }
                                                        is_ems_pc_admin={
                                                            is_ems_pc_admin
                                                        }
                                                    />
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="header-user-col">
                                        <div className="alert-menu">
                                            <img src={imgNotifications} />
                                        </div>
                                        <div className="header-user">
                                            {user.role ? (
                                                <>
                                                    <img src={imgAvatar} />
                                                    <Dropdown as={NavItem}>
                                                        <Dropdown.Toggle
                                                            id="nav-dropdown"
                                                            as={NavLink}
                                                        >
                                                            <div className="user">
                                                                <span>
                                                                    {user.name}
                                                                </span>
                                                                <span>
                                                                    {user &&
                                                                    user.role
                                                                        ? user.role
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={
                                                                    this.props
                                                                        .onLogout
                                                                }
                                                            >
                                                                Logout
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        {this.state.showCreatedAppModel === true && (
                            <AddApplicationModal
                                editPrevetId={this.state.editPrevetId}
                                editPrevet={this.state.editPrevet}
                                showCreatedAppModel={
                                    this.state.showCreatedAppModel
                                }
                                handleCloseCreatedAppModel={() =>
                                    this.setState({
                                        showCreatedAppModel: false,
                                    })
                                }
                                getPreappData={() => this.handler()}
                                fullApplicationUrl={this.state.CreateUrl}
                                user={user}
                            />
                        )}

                        {this.state.showEmsBootModal && (
                            <EMSBootModal
                                isOpen={this.state.showEmsBootModal}
                                close={() =>
                                    this.setState({ showEmsBootModal: false })
                                }
                                user={this.props.user}
                            />
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(Header);
